export default {
  title: 'Marketing Activities',
  activityManagement: 'Activity Management',
  activityList: 'Activity List',
  drawRecord: 'Draw Record',
  giftClaimRecord: 'Gift Claim Record',
  activityTemplate: 'Activity Template',
  marketingData: 'Marketing Data',
};
